import { render, staticRenderFns } from "./DomainUserSelect.vue?vue&type=template&id=59f97d2a&"
import script from "./DomainUserSelect.vue?vue&type=script&lang=js&"
export * from "./DomainUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports